<form [formGroup]="restaurantForm">
  <div class="filters-card k-card k-card-type-rich">
    <div class="k-card-header"><strong>New Lab Restaurant:</strong></div>
    <div class="k-card-body filters-section">
      <div class="header-style">
        <label for="restaurantName"><strong>Restaurant Number *</strong></label>
        <kendo-textbox
          class="tier-name-edit-input"
          [maxlength]="25"
          formControlName="restaurantNumber"
          placeholder="Restaurant Number"
        ></kendo-textbox>
        <label><strong>Reporting Unit *</strong></label>
        <kendo-combobox
          class="task-dropdown"
          [data]="reportingUnits.data"
          formControlName="selectedReportingUnit"
          textField="ruNm"
          valueField="ruNo"
          [filterable]="true"
          (filterChange)="updateReportingUnitSearch($event)"
          placeholder="Start typing reporting unit name..."
        ></kendo-combobox>
        <label for="parToken"><strong>PAR Token</strong></label>
        <kendo-textbox
          class="tier-name-edit-input"
          [maxlength]="25"
          formControlName="parToken"
          placeholder="PAR token (optional)"
        ></kendo-textbox>
        <kendo-badge-container>
          <button
            kendoButton
            [disabled]="restaurantForm.invalid"
            type="submit"
            size="medium"
            fillMode="outline"
            (click)="saveRestaurant()"
            themeColor="success"
          >
            Create Lab
          </button>
        </kendo-badge-container>
      </div>
    </div>
  </div>
</form>

<div class="tab-content-container">
  <div class="tab-box k-card k-card-type-rich">
    <app-data-grid
      size="small"
      [dataItems]="restaurants"
      [columns]="columns"
      [state]="state"
      (dataStateChange)="onDataStateChanged($event)"
      [filterable]="'menu'"
    >
      <ng-template columnTemplate field="name" let-row="row">
        {{ row.name }}
        <fa-icon
          kendoTooltip
          [title]="'King Restaurant in Tier ' + row.priceTierName"
          class="icon-text king-icon"
          *ngIf="row.isKing"
          [icon]="['fas', 'crown']"
        ></fa-icon>

        <fa-icon
          kendoTooltip
          title="Lab Restaurant"
          class="icon-text lab-icon"
          *ngIf="row.isVirtual"
          [icon]="['fas', 'flask-gear']"
        ></fa-icon>
      </ng-template>
      <ng-template columnTemplate field="parToken" let-row="row">
        <div class="partoken-edit">
          <input
            type="text"
            kendoTextBox
            [(ngModel)]="row.parToken"
            [disabled]="!row._onClick"
          />
          <kendo-badge-container>
            <button
              kendoButton
              size="small"
              fillMode="outline"
              (click)="onParTokenEdit(row)"
              themeColor="success"
            >
              <fa-icon *ngIf="!row._onClick" [icon]="['fas', 'pen']"></fa-icon>
              <fa-icon *ngIf="row._onClick" [icon]="['fas', 'check']"></fa-icon>
            </button>
          </kendo-badge-container>
        </div>
      </ng-template>
    </app-data-grid>
  </div>
</div>
